'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _withForm = require('constructicon/with-form');

var _withForm2 = _interopRequireDefault(_withForm);

var _validators = require('constructicon/lib/validators');

var validators = _interopRequireWildcard(_validators);

var _authentication = require('../../api/authentication');

var _form = require('../../utils/form');

var _form2 = require('constructicon/form');

var _form3 = _interopRequireDefault(_form2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginForm = function (_Component) {
  _inherits(LoginForm, _Component);

  function LoginForm() {
    _classCallCheck(this, LoginForm);

    var _this = _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call(this));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.state = {
      status: 'empty',
      errors: []
    };
    return _this;
  }

  _createClass(LoginForm, [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this2 = this;

      e.preventDefault();

      var _props = this.props,
          clientId = _props.clientId,
          country = _props.country,
          form = _props.form,
          onSuccess = _props.onSuccess;


      return form.submit().then(function (data) {
        _this2.setState({
          errors: [],
          status: 'fetching'
        });

        return (0, _authentication.signIn)(_extends({
          clientId: clientId,
          country: country
        }, data)).then(function (result) {
          _this2.setState({ status: 'fetched' });

          return onSuccess(result);
        }).catch(function (error) {
          var message = (0, _get2.default)(error, 'data.error.message');

          switch (error.status) {
            case 401:
            case 404:
              return _this2.setState({
                status: 'failed',
                errors: [{ message: 'Invalid Email or Password.' }]
              });
            default:
              return _this2.setState({
                status: 'failed',
                errors: message ? [{ message: message }] : []
              });
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          disableInvalidForm = _props2.disableInvalidForm,
          form = _props2.form,
          formComponent = _props2.formComponent,
          inputField = _props2.inputField,
          submit = _props2.submit;
      var _state = this.state,
          status = _state.status,
          errors = _state.errors;


      return _react2.default.createElement(
        _form3.default,
        _extends({
          errors: errors,
          isDisabled: disableInvalidForm && form.invalid,
          isLoading: status === 'fetching',
          noValidate: true,
          onSubmit: this.handleSubmit,
          submit: submit
        }, formComponent),
        (0, _form.renderFormFields)(form.fields).map(function (field) {
          var Tag = (0, _form.renderInput)(field.type);
          return _react2.default.createElement(Tag, _extends({ key: field.name }, field, inputField));
        })
      );
    }
  }]);

  return LoginForm;
}(_react.Component);

LoginForm.propTypes = {
  /**
   * The clientId for a valid OauthApplication (EDH only)
   */
  clientId: _propTypes2.default.string,

  /**
   * Country for new user (EDH only)
   */
  country: _propTypes2.default.oneOf(['au', 'nz', 'uk', 'us', 'ie']),

  /**
   * Disable form submission when invalid
   */
  disableInvalidForm: _propTypes2.default.bool,

  /**
   * Fields to be passed to the form HOC
   */
  fields: _propTypes2.default.object,

  /**
   * Props to be passed to the Form component
   */
  formComponent: _propTypes2.default.object,

  /**
   * Props to be passed to the InputField component
   */
  inputField: _propTypes2.default.object,

  /**
   * The onSuccess event handler
   */
  onSuccess: _propTypes2.default.func.isRequired,

  /**
   * The label for the form submit button
   */
  submit: _propTypes2.default.string
};

LoginForm.defaultProps = {
  disableInvalidForm: false,
  fields: {},
  submit: 'Log in'
};

var form = function form(props) {
  return {
    fields: (0, _merge2.default)({
      email: {
        label: 'Email address',
        type: 'email',
        order: 1,
        required: true,
        validators: [validators.required('Email is a required field'), validators.email('Must be a valid email')]
      },
      password: {
        label: 'Password',
        type: 'password',
        order: 2,
        required: true,
        validators: [validators.required('Password is a required field'), validators.greaterThan(7, 'Must be at least 8 characters')]
      }
    }, props.fields)
  };
};

exports.default = (0, _withForm2.default)(form)(LoginForm);


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/components/login-form/index.js
// module id = 1438
// module chunks = 0